import type { EinbuergerungsPayload } from '@/core/types';

import type { AppDefinition } from '../types';
import { EinbuergerungstestAppHome } from './AppHome';
import { CardBack } from './CardBack';
import { CardFront } from './CardFront';
import { MissRow } from './MissRow';

export const einbuergerungsApp: AppDefinition<EinbuergerungsPayload> = {
  id: 'einbuergerungstest',
  display_name: 'Einbürgerungstest',
  CardFront,
  CardBack,
  Home: EinbuergerungstestAppHome,
  MissRow,
};
